import { useEffect } from 'react';

const useMediaSession = ({
  currentItem,
  isCountdown,
  isRadioMode,
  isPlaying,
  videoElement, // Changed from videoRef
  onExitRadio,
  onNext,
  setRadioMuted,
}) => {
  useEffect(() => {
    if (!('mediaSession' in navigator) || !currentItem || isCountdown) return;

    const updateMetadata = () => {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: currentItem.title || 'Unknown Title',
        artist: currentItem.speaker || 'BAWS.in Audio',
        album: 'Babasaheb Ambedkar Speeches Collection Volume 40',
        artwork: [
          {
            src:
              currentItem.thumbnail || 'https://baws.in/assets/images/logo.png',
            sizes: '512x512',
            type: 'image/png',
          },
        ],
      });
    };

    updateMetadata();

    navigator.mediaSession.playbackState = isPlaying ? 'playing' : 'paused';

    const allActions = [
      'play',
      'pause',
      'seekbackward',
      'seekforward',
      'seekto',
      'previoustrack',
      'nexttrack',
      'stop',
    ];

    let targetHandlers = {};

    if (isRadioMode) {
      targetHandlers = {
        pause: () => {
          if (videoElement) {
            videoElement.muted = true;
            videoElement.pause();
          }
          if (setRadioMuted) setRadioMuted(true);
          navigator.mediaSession.playbackState = 'paused';
        },
        stop: () => {
          if (videoElement) {
            videoElement.muted = true;
            videoElement.pause();
          }
          if (setRadioMuted) setRadioMuted(true);
          navigator.mediaSession.playbackState = 'paused';
        },
      };
    } else {
      targetHandlers = {
        play: () => videoElement?.play(),
        pause: () => videoElement?.pause(),
        stop: () => videoElement?.pause(),
        nexttrack: () => {
          if (onNext) onNext();
        },
        seekbackward: (details) => {
          const skip = details.seekOffset || 10;
          if (videoElement)
            videoElement.currentTime = Math.max(
              videoElement.currentTime - skip,
              0
            );
        },
        seekforward: (details) => {
          const skip = details.seekOffset || 10;
          if (videoElement)
            videoElement.currentTime = Math.min(
              videoElement.currentTime + skip,
              videoElement.duration
            );
        },
        seekto: (details) => {
          if (videoElement) {
            if (details.fastSeek && 'fastSeek' in videoElement) {
              videoElement.fastSeek(details.seekTime);
            } else {
              videoElement.currentTime = details.seekTime;
            }
          }
        },
      };
    }

    allActions.forEach((action) => {
      try {
        navigator.mediaSession.setActionHandler(
          action,
          targetHandlers[action] || null
        );
      } catch (e) {
        // Ignore
      }
    });
  }, [
    currentItem,
    isCountdown,
    isRadioMode,
    isPlaying,
    onExitRadio,
    onNext,
    videoElement,
    setRadioMuted,
  ]);
};

export default useMediaSession;
